<template>
  <Layout>
    <PageHeader />
    <b-row>
       <b-col md="12">
      <transition name="slide-error" mode="out-in">
                    <b-alert id="errors" variant="danger" :show="error_message == true"  dismissible @dismissed="error_message = !error_message">
                      <p class="font-size-14">Oops! Please correct the following errors in your submission</p>
                      <ul>
                        <li v-for="(error, key) in error_reponse">
                          {{error[0]}}
                        </li>
                      </ul>
                      <small>Please Try Again. If this error persists, please contact support.</small>
                    </b-alert>
                    
                  </transition>
                </b-col>
                <b-col md="12">
                    <transition name="slide-success" mode="out-in">
                  <b-alert id="success-message" variant="success" :show="success_message"  dismissible @dismissed="success_message = !success_message">
                      <p class="font-size-14">{{success_messagetext}}</p>
                    </b-alert>
                  </transition>
                  </b-col>
      <b-col md="8">
         <b-overlay :show="loadingMenus">
        <b-card class="border-radius-1em border shadow-none">
          <div class="d-flex">
          <h3 class="mt-1" v-if="editable.title == false"><a class="" @click="editable.title = true"><i class="bx bx-edit-alt"></i></a> {{menu.name}} </h3>
          <a class="" v-if="editable.title == true" @click="editable.title = false"><i class="bx bx-x font-size-24"></i></a>
          <b-form-input v-if="editable.title == true" type="text" name="name" v-model="menu.name" class="ml-2 underline-input font-size-20 mb-auto w-auto p-0"></b-form-input>
          
          <!--<a class="btn btn-primary ml-auto mb-3 mr-2 btn-rounded float-right" @click="menulink = JSON.parse(JSON.stringify(menulinkdata)), itemEditorAction = 'add', addPanel = true"> Add Menu Item </a>-->
          <b-col class="d-flex">
                   <div
                        class="form-check form-switch form-switch-sm my-2 ml-auto mr-4"
                        dir="ltr"
                      >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          :id="`SwitchCheckSizeactive`"
                          v-model="menu.active"
                          :value="menu.active"
                          name="active"
                          
                        />
                        <label class="form-check-label" :for="`SwitchCheckSizeactive`" 
                          >Active</label
                        >
                    </div>
                </b-col>
          <a class="btn btn-success ml-auto btn-rounded mb-3" @click="saveMenu()">
            <i class="bx bx-save">
            </i> 

            Save Menu
          </a>
        </div>
          <nested-draggable :parentlink="''" :domain="default_domain" :menuitems="menu.menuitems" @add-menu-item="addToMenu" @edit-menu-item="editMenuItem" @delete-menu-item="deleteMenuItem" />

        </b-card>
         </b-overlay>
      </b-col>
   
      <b-col md="4">
        <MenuItemEditor :menulink="menulink" @add-menu-item="addToMenu"  :action="itemEditorAction" :activeDropdown="dropdownResource" :user="$attrs.user"></MenuItemEditor>
      </b-col>
      <!--<rawDisplayer class="col-3" :value="list" title="List" />-->
       <SideSlidePanel :editPanel="addPanel" :panelClass="'edit-sidepanel-slim position-fixed'" @close-panel="addPanel = false">
    <MenuItemEditor :menulink="menulink" @add-menu-item="addToMenu"  :action="itemEditorAction" :activeDropdown="dropdownResource" :user="$attrs.user"></MenuItemEditor>
  </SideSlidePanel>
    </b-row>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import nestedDraggable from "../../components/widgets/nestedDraggable";
import MenuItemEditor from "../../components/widgets/page-builder/MenuItemEditor";
import SideSlidePanel from "../../components/widgets/SideSlidePanel";
import { EventBus }  from '../../app';
export default {
  name: "nested-example",
  display: "Nested",
  order: 15,
  components: {
    Layout, PageHeader, nestedDraggable, MenuItemEditor, SideSlidePanel
  },
  data() {
    return {
      list: [
        {
          name: "task 1",
          menuitems: [
            {
              name: "task 2",
              menuitems: []
            }
          ]
        },
        {
          name: "task 3",
          menuitems: [
            {
              name: "task 4",
              menuitems: []
            }
          ]
        },
        {
          name: "task 5",
          menuitems: []
        }
      ],
      menu: '',
      menu_raw: '',
      editable: {
        title: false,
        description: false,
      },
      default_domain: '',
      error_message: 'Could not update menu',
      error_reponse: [],
      loadingMenus: false,
      success_message: false,
      success_messagetext: 'Menu updated',
      categories: [],
      collections: [],
      pages: [],
      addPanel: false,
      itemEditorAction: 'add',
      dropdownResource: 'pages',
      menulink: {
        company_web_menu_id: '',
        name: '',
        description: '',
        label: '',
        resource: '',
        menuitems: [],
        company_web_page_id: 0,
        resource_id: '',
        link: '',
      },
      menulinkdata: {
        company_web_menu_id: '',
        name: '',
        description: '',
        label: '',
        resource: '',
        menuitems: [],
        company_web_page_id: 0,
        resource_id: '',
        link: '',
      }
    };
  },
  created(){
    this.getMenu();
    this.getDefaultDomain();
  },
  mounted(){
    let self = this;
    EventBus.$on('add-dropdown', function (payload) {
      console.log(payload);
      self.menu.menuitems = payload;
    });
  },
  methods: {
    getDefaultDomain(){
      axios.get('/api/company/web/domain/default', {headers : {'Authorization' : 'Bearer '+this.$attrs.user.api_token}}).then(response => {
        this.default_domain = response.data;
      }).catch(error => {
        console.log(error);
      });
    },
    getMenu(){
      axios.get('/api/company/web/menu/'+this.$attrs.id, {headers : {'Authorization' : 'Bearer '+this.$attrs.user.api_token}}).then(response => {
        this.menu = response.data;
      }).catch(error => {
        console.log(error);
      });
    },
    saveMenu(){
      this.loadingMenus = true;
      axios.post('/api/company/web/menu/'+this.$attrs.id+'/update', this.menu, {headers : {'Authorization' : 'Bearer '+this.$attrs.user.api_token}}).then(response => {
          let self = this;
            setTimeout(function(){
              self.loadingMenus = false;
              self.success_message = true;
              self.success_messagetext = "Menu updated";
            }, 500);

            setTimeout(function(){
              self.success_message = false;
            }, 1500);
        }).catch(error => {
          this.error_reponse = errors.response.data.errors;
          this.error_message = true;
        });
    },
    deleteMenuItem(){

    },
    openAddPanel(){
      //this.addPanel = true;
    },
    addToMenu(action, type, item){
      console.log(item);
        if(this.itemEditorAction == 'add'){
            if(type == 'custom'){
              this.menu.menuitems.push(JSON.parse(JSON.stringify(item)));
              this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
           }else if(type == 'page'){
              this.menu.menuitems.push(JSON.parse(JSON.stringify(item)));
              this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
            }else if(type == 'category'){
              item.link = type + '/' + item.link;
              this.menu.menuitems.push(JSON.parse(JSON.stringify(item)));
              this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
            }else if(type == 'collection'){
              item.link = type + '/' + item.link;
              this.menu.menuitems.push(JSON.parse(JSON.stringify(item)));
              this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
            }else{
              this.menu.menuitems.push(JSON.parse(JSON.stringify(item)));
              this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
            }
        }
        if(this.itemEditorAction == 'edit'){
          this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
        }
        this.menulink = JSON.parse(JSON.stringify(this.menulinkdata));
        this.itemEditorAction = 'add';
       //this.addPanel = false;
    },
    addDropdown(){

    },
    editMenuItem (payload){
      //console.log(payload);
      this.dropdownResource = payload.resource;
      this.itemEditorAction = 'edit';
      this.menulink = payload;
      //this.addPanel = true;
    }


  },
  watch: {
    menu: function (menudata){
      console.log(menudata);
    }
  }
};
</script>
<style scoped></style>